declare namespace $ {

	type $mol_check__checked_shm_hitalama_color_switch_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_color_switch['option_checked'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__sub_shm_hitalama_color_switch_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_check['sub'] >
	>
	type $mol_check__enabled_shm_hitalama_color_switch_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_color_switch['option_enabled'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	type $mol_check__hint_shm_hitalama_color_switch_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_color_switch['option_hint'] >
		,
		ReturnType< $mol_check['hint'] >
	>
	type $mol_check__minimal_height_shm_hitalama_color_switch_5 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_check['minimal_height'] >
	>
	type $mol_check__attr_shm_hitalama_color_switch_6 = $mol_type_enforce<
		({ 
			'shm_hitalama_color_transparent': ReturnType< $shm_hitalama_color_switch['transparent'] >,
			'shm_hitalama_color_auto': ReturnType< $shm_hitalama_color_switch['color_auto'] >,
		})  & ReturnType< $mol_check['attr'] >
		,
		ReturnType< $mol_check['attr'] >
	>
	type $mol_check__style_shm_hitalama_color_switch_7 = $mol_type_enforce<
		({ 
			'backgroundColor': ReturnType< $shm_hitalama_color_switch['color'] >,
		}) 
		,
		ReturnType< $mol_check['style'] >
	>
	export class $shm_hitalama_color_switch extends $mol_switch {
		option_enabled( id: any): ReturnType< $shm_hitalama_color_switch['enabled'] >
		transparent( id: any): boolean
		color_auto( id: any): boolean
		color( id: any): string
		Option( id: any): $mol_check
		colors( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=switch.view.tree.d.ts.map